module.exports = __webpack_public_path__ + "resources/img/solution_game_kr_m_v2.3db356fdd03ecd1a8e91dcac93849b45.png";